import theme from "../../../Constants/theme";

export const userManagementContainer = {
  display: "flex",
  bgcolor: theme.backgroundColors.dark.primary,
  p: 6,
  width: "100%",
  height: "100vh",
  alignItems: "center",
  justifyContent: "center",
};

export const userManagementPaper = {
  display: "flex",
  p: 4,
  width: "80%",
  color: theme.textColors.dark.primary,
  bgcolor: theme.backgroundColors.dark.tertiary,
  height: "80%",
  alignItems: "flex-start",
  flexDirection: "column",
  borderRadius: theme.borderRadius.lg,
};
